<template>
  <div class="header">
    <img class="logo" src="../../assets/Dimerco-logo.svg" />
    <h1>Track Your Cargo</h1>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  background-color: #fff;
  gap: 2.6rem;
}

.logo {
  width: 15.3rem;
  margin-left: 5rem;
}

h1 {
  font-size: 3.2rem;
  font-family: MyDimerco-WorkSansBold;
  color: #465363;
}

@media screen and (max-width: 1366px) {
  .logo {
    width: 12rem;
  }
  h1 {
    font-size: 2.2rem;
  }
}
</style>
